const FEATURE_HELP_URLS = {
  agent_bots: 'https://hichat.asia/docs/agent-bots',
  agents: 'https://hichat.asia/docs/61-quan-ly-nhan-vien',
  audit_logs: 'https://hichat.asia/docs/audit-logs',
  automation: 'https://hichat.asia/docs/64-automation-va-macros',
  campaigns: 'https://hichat.asia/docs/campaigns',
  canned_responses: 'https://hichat.asia/docs/65-thu-mau-phan-hoi',
  channel_email: 'https://hichat.asia/docs/email',
  channel_facebook: 'https://hichat.asia/docs/fb',
  custom_attributes: 'https://hichat.asia/docs/custom-attributes',
  dashboard_apps: 'https://hichat.asia/docs/dashboard-apps',
  help_center: 'https://hichat.asia/docs/help-center',
  inboxes: 'https://hichat.asia/docs/2-kt-noi-kenh',
  integrations: 'https://hichat.asia/docs/integrations',
  labels: 'https://hichat.asia/docs/63-quan-ly-nhan',
  macros: 'https://hichat.asia/docs/64-automation-va-macros',
  message_reply_to: 'https://hichat.asia/docs/reply-to',
  reports: 'https://hichat.asia/docs/reports',
  sla: 'https://hichat.asia/docs/sla',
  team_management: 'https://hichat.asia/docs/62-quan-ly-nhom',
  webhook: 'https://hichat.asia/docs/webhooks',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
